import auth from './authSlice'

const reducer = auth

export default reducer